import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=d589cca8&scoped=true&"
import script from "./detail-dialog.vue?vue&type=script&lang=js&"
export * from "./detail-dialog.vue?vue&type=script&lang=js&"
import style0 from "./detail-dialog.vue?vue&type=style&index=0&id=d589cca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d589cca8",
  null
  
)

export default component.exports